<template>
  <div class="stub-event-swiper t-main-services__swiper">
    <swiper ref="swiper" :options="videoSwiperOption" class="stub-event-swiper__container">
      <template>
        <swiper-slide class="stub-event-swiper__swiper-slide">
          <iframe class="stub-event-swiper__swiper-video" src="https://vkvideo.ru/video_ext.php?oid=-95539846&id=456239444&hd=2&hash=e35de19a2800e245&hd=2&js_api=1" width="380" height="256" style="background-color: #000" allow="encrypted-media; fullscreen; picture-in-picture; screen-wake-lock;" frameborder="0" allowfullscreen></iframe>
          <p class="stub-event-swiper__swiper-title">Приглашение от Сергея Игнатова</p>
        </swiper-slide>
        <swiper-slide class="stub-event-swiper__swiper-slide">
          <iframe class="stub-event-swiper__swiper-video" src="https://vkvideo.ru/video_ext.php?oid=-95539846&id=456239445&hd=2&hash=e5e92874e1554348&hd=2&js_api=1" width="380" height="256" style="background-color: #000" allow="encrypted-media; fullscreen; picture-in-picture; screen-wake-lock;" frameborder="0" allowfullscreen></iframe>
          <p class="stub-event-swiper__swiper-title">Приглашение от Виктора Засорина</p>
        </swiper-slide>
        <swiper-slide class="stub-event-swiper__swiper-slide">
          <iframe class="stub-event-swiper__swiper-video" src="https://vkvideo.ru/video_ext.php?oid=-95539846&id=456239447&hash=d558e9fe53030d9d&hd=2&js_api=1" width="380" height="256" style="background-color: #000" allow="encrypted-media; fullscreen; picture-in-picture; screen-wake-lock;" frameborder="0" allowfullscreen></iframe>
          <p class="stub-event-swiper__swiper-title">Приветствие в Axoft от Юрия Рожнова</p>
        </swiper-slide>
      </template>
    </swiper>
    <div class="stub-event-swiper__swiper-btn stub-event-swiper--btn-prev" slot="button-prev"><chevron-left-svg /></div>
    <div class="stub-event-swiper__swiper-btn stub-event-swiper--btn-next" slot="button-next"><chevron-right-svg /></div>
  </div>
</template>

<script>
import ChevronLeft from '@assets/img/ChevronLeft.svg?inline'
import ChevronRight from '@assets/img/ChevronRight.svg?inline'

export default {
  name: 'stub-event-swiper',
  components: {
    'chevron-left-svg': ChevronLeft,
    'chevron-right-svg': ChevronRight
  },
  data() {
    return {
      vkPlayers: [],
      videoSwiperOption: {
        slidesPerView: 3,
        spaceBetween: 30,
        navigation: {
          nextEl: '.stub-event-swiper--btn-next',
          prevEl: '.stub-event-swiper--btn-prev'
        },
        breakpoints: {
          920: {
            slidesPerView: 1,
            spaceBetween: 15,
          },
          1300: {
            slidesPerView: 2,
            spaceBetween: 15
          }
        },
        on: {
          slideChange: () => {
            this.stopAllPlayers()
          }
        }
      }
    }
  },
  mounted() {
    this.addVkVideoScript()
  },
  methods: {
    addVkVideoScript() {
      const scriptSrc = "https://vk.com/js/api/videoplayer.js"

      if (!document.querySelector(`script[src="${scriptSrc}"]`)) {
        const script = document.createElement("script")
        script.src = scriptSrc
        script.async = true
        script.onload = () => {
          this.initVkPlayers()
        }
        document.head.appendChild(script)
      } else {
        console.log("VK video script already added")
      }
    },
    initVkPlayers() {
      this.vkPlayers = []

      const iframes = this.$el.querySelectorAll('iframe.stub-event-swiper__swiper-video')

      iframes.forEach((iframe) => {
        if (VK && typeof VK.VideoPlayer === 'function') {
          try {
            const player = new VK.VideoPlayer(iframe, {
              autoplay: false
            })

            player.on('started', () => {
              this.vkPlayers.forEach(p => {
                if (p !== player) {
                  try { p.pause() } catch (e) { /* noop */ }
                }
              })
            })

            player.on('resumed', () => {
              this.vkPlayers.forEach(p => {
                if (p !== player) {
                  try { p.pause() } catch (e) { /* noop */ }
                }
              })
            })

            this.vkPlayers.push(player)
          } catch (e) {}
        }
      })
    },
    stopAllPlayers() {
      if (this.vkPlayers.length) {
        this.vkPlayers.forEach(p => {
          try {
            p.pause()
          } catch (e) {}
        })
      }
    }
  }
}
</script>

<style lang="sass">
@import "~@src/sass/params"

.stub-event-swiper
  position: relative
  margin-bottom: 48px

  @media screen and (max-width: 1300px)
    margin-bottom: 32px

  @media screen and (max-width: 1160px)
    margin-bottom: 20px

  @media screen and (max-width: 920px)
    margin-bottom: 12px

  &__container
    display: flex
    flex-wrap: wrap

    @media screen and (max-width: 1300px)
      margin-inline: 15px !important

    @media screen and (max-width: 1160px)
      margin-inline: 30px !important

    @media screen and (max-width: 920px)
      margin-inline: 60px !important
      padding-bottom: 6px !important

    video
      transform: none !important

  &__swiper-slide
    height: auto

  &__swiper-video
    width: 100%
    border-radius: 6px

  &__swiper-title
    font-size: 23px
    font-weight: 600
    padding-top: 6px

  &__swiper-btn
    --swiper-btn-offset: -65px

    position: absolute
    top: calc(50% - 24px)
    z-index: 1
    display: flex
    align-items: center
    justify-content: center
    border-radius: 0.25em
    cursor: pointer
    height: 48px
    width: 48px
    margin: 0
    padding: 0
    color: #929292
    background: transparent
    border: none

    @media screen and (max-width: $desktop-medium)
      --swiper-btn-offset: -55px

    @media screen and (max-width: $desktop-small)
      --swiper-btn-offset: -40px

    @media screen and (max-width: $tablet-size)
      --swiper-btn-offset: -25px

    @media screen and (max-width: $mobile-size)
      --swiper-btn-offset: 2px

    &.stub-event-swiper--btn-prev
      left: var(--swiper-btn-offset)

    &.stub-event-swiper--btn-next
      right: var(--swiper-btn-offset)

    &.swiper-button-disabled
      pointer-events: none
      opacity: 0.2

    &:hover
      background: #00a8e8
      color: white

    &:active
      background: #00a8e8 !important
      color: white !important

</style>



// WEBPACK FOOTER //
// src/templates/components/ui-components/stub-event-swiper/index.vue